import { render } from "./select-vendors.vue?vue&type=template&id=78d77561&scoped=true"
import script from "./select-vendors.vue?vue&type=script&lang=js"
export * from "./select-vendors.vue?vue&type=script&lang=js"

import "./select-vendors.vue?vue&type=style&index=0&id=78d77561&scoped=true&lang=css"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d77561"]])

export default __exports__